module.exports = [
	{
		"start": 0.099,
		"text": "A lot of people say that we need to go back to our country. But this is really the only country we know."
	},
	{
		"start": 6.78,
		"text": "I don't remember anything about Pakistan. My parents immigrated here with me when I was 5 months old."
	},
	{
		"start": 13.96,
		"text": "So I've lived in Houston, Texas, for practically my whole life."
	},
	{
		"start": 17.56,
		"text": "My family has never had the opportunity to travel or go on vacation or anything like that, just because of that lingering fear that we had."
	},
	{
		"start": 26.54,
		"text": "You know, in one second we could be enjoying life and the next second we could be deported or our family could be separated."
	},
	{
		"start": 33.92,
		"text": "We are a mixed-status household. My parents, they are both undocumented."
	},
	{
		"start": 39.53,
		"text": "I am the first to have DACA, and my three siblings, they’re all U.S. citizens. They had better opportunities."
	},
	{
		"start": 48.66,
		"text": "If they were sick or if they needed to go to the dentist or anything like that, they really had easy access because the government would support them."
	},
	{
		"start": 56.409,
		"text": "We lived in a really low-income household, so for them those benefits were really provided."
	},
	{
		"start": 60.87,
		"text": "But for me, our parents would always have to put in every dollar they had just so that I could go see the doctor."
	},
	{
		"start": 66.799,
		"text": "Even as a teenager, I had to think about, \"what do I want to do if I don't have the access to education?"
	},
	{
		"start": 73.14,
		"text": "What do I have to do if I won't be able to work or if I won't have a future?\""
	},
	{
		"start": 77.02,
		"text": "So I had to be an adult at a very early age. I remember specifically when I was a freshman in high school, my parents and I, we wanted"
	},
	{
		"start": 86.22,
		"text": "to apply for DACA right away. \"We need to turn in this application because this document is going to be your future.\""
	},
	{
		"start": 93.59,
		"text": "Currently I'm a student at the University of Houston. I'm studying to go into nursing."
	},
	{
		"start": 99.34,
		"text": "If I lose the protection of DACA, I don't know if I'll be able to work as a nurse in"
	},
	{
		"start": 103.66,
		"text": "the future or be able to find jobs in the medical field because that field is so restricted and also it's very government mandated."
	},
	{
		"start": 112.14,
		"text": "If I do lose DACA I know I would have to completely rethink my life."
	}
];


//////////////////
// WEBPACK FOOTER
// ../assets/transcripts/uzair.json
// module id = 12
// module chunks = 0